"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservedSlug = exports.Referrals = exports.BookingsQueryParams = void 0;
var BookingsQueryParams;
(function (BookingsQueryParams) {
    BookingsQueryParams["REFERRAL"] = "referral";
    BookingsQueryParams["STAFF"] = "staff";
    BookingsQueryParams["LOCATION"] = "location";
    BookingsQueryParams["BOOKING_ID"] = "bookingId";
    BookingsQueryParams["SERVICE_ID"] = "service";
    BookingsQueryParams["AVAILABILITY_SLOT"] = "slot";
    BookingsQueryParams["TIMEZONE"] = "timezone";
    BookingsQueryParams["DYNAMIC_PRICING"] = "dynamic-pricing";
    BookingsQueryParams["FILLED_FIELDS"] = "filledFields";
    BookingsQueryParams["PUBLIC_DATA_OVERRIDES"] = "publicDataOverrides";
    BookingsQueryParams["ECOM"] = "ecom";
    BookingsQueryParams["CONTINUE_SHOPPING_URL"] = "continueShoppingUrl";
    BookingsQueryParams["DATE"] = "date";
    BookingsQueryParams["RESOURCE"] = "resource";
})(BookingsQueryParams = exports.BookingsQueryParams || (exports.BookingsQueryParams = {}));
var Referrals;
(function (Referrals) {
    Referrals["BOOKINGS_FORM_WIDGET_WITH_CART"] = "bookings_form_widget_with_cart";
})(Referrals = exports.Referrals || (exports.Referrals = {}));
var ReservedSlug;
(function (ReservedSlug) {
    ReservedSlug["CALENDAR_COMPLEX_NAVIGATION"] = "_select-date-time";
})(ReservedSlug = exports.ReservedSlug || (exports.ReservedSlug = {}));
//# sourceMappingURL=types.js.map